import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import { ImMenu } from "react-icons/im";
import { Link, useLocation } from "react-router";
import { cn } from "../../../lib/utils";
import { AppContext } from "../../AppProvider";
import { HoveredLink, Menu, MenuItem } from "../ui/navbar-menu";
  
const Header = () => {
  const [loading, setLoading] = useState(true);
  const { uri } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${uri}practice-areas/`)
      .then((response) => {
        setCardData(response.data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <span className="loading loading-bars loading-lg"></span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Error: {error}</p>
      </div>
    );
  }

  return (
    <header className="w-full pt-2">
      <Navbar className="hidden lg:block mb-10 shadow-md py-3 border border-gray-300 rounded" cardData={cardData} />
      <Phonenav className="lg:hidden px-3" cardData={cardData} />
    </header>
  );
};
export default Header;

function Navbar({ className, cardData }) {
  const location = useLocation();
  const [active, setActive] = useState(null);

  useEffect(() => {
    setActive(location.pathname);
  }, [location]);

  const isActive = (path) => location.pathname === path;
  const activeClass = "border-b-2 border-blue-500 text-blue-500 font-semibold";

  return (
    <div className={cn("relative inset-x-0 z-50 bg-white ", className)}>
      <Menu setActive={setActive}>
        <HoveredLink to="/" className={isActive("/") ? activeClass : ""}>
          Home
        </HoveredLink>
        <HoveredLink
          to="/About"
          className={isActive("/About") ? activeClass : ""}>
          About us
        </HoveredLink>

        {/* Services Menu  Team & Careers*/}
         {/* Services Menu */}
         <MenuItem setActive={setActive} to="Services" active={active} item="Our services">
          <div className="flex flex-col space-y-2 ">
            <HoveredLink
              to="/Services/Organization-Development"
              className={
                isActive("/Services/Organization-Development")
                  ? activeClass
                  : ""
              }>
              Organization Development
            </HoveredLink>
            <HoveredLink
              to="/Services/Research&Evaluation"
              className={
                isActive("/Services/Research&Evaluation") ? activeClass : ""
              }>
              Research and Evaluation
            </HoveredLink>
          </div>
        </MenuItem>

        <MenuItem setActive={setActive} to="/practice-areas" active={active} item="Sectoral presence">
          <div className="flex flex-col space-y-2">
            {cardData?.map((item) => (
              <HoveredLink
                key={item.id}
                to={`/practice-areas/${item.id}`}
                className={isActive(`/practice-areas/${item.id}`) ? activeClass : ""}
              >
                {item.name}
              </HoveredLink>
            ))}
          </div>
        </MenuItem>
        <MenuItem setActive={setActive} to="/team-career/team" active={active} item="Team & career">
          <div className="flex flex-col space-y-2 ">
            <HoveredLink
             to="/team-career/team" className={isActive("/team-career/team") ? activeClass : ""}>
              Team members
            </HoveredLink>
            <HoveredLink
              to="/team-career/career"
              className={
                isActive("/team-career/career") ? activeClass : ""
              }>
              Career Opportunity
            </HoveredLink>
          </div>
        </MenuItem>
        <HoveredLink
          to="/work-reach"
          className={isActive("/work-reach") ? activeClass : ""}>
          Our work & reach
        </HoveredLink>
      </Menu>
    </div>
  );
}

const Phonenav = ({ className, cardData }) => {
  const [country, setCountry] = useState("CBSG Canada");
  const location = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      setCountry((prev) => (prev === "CBSG Canada" ? "CBSG Bangladesh" : "CBSG Canada"));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const isActive = (path) => location.pathname === path;
  const activeClass = "text-blue-500 font-semibold";

  return (
    <div className="block lg:hidden bg-white shadow-xl mb-10 border border-gray-300 rounded">
      <div className="navbar z-50 w-full">
        <div className="flex justify-between items-center w-full py-2">
          <div className="mr-2 inline-flex max-w-[19.1rem] md:max-w-[30rem]">
            <Link to="/">
              <img
                src="/logo.png"
                alt="CBSG LOGO"
                className="w-16 px-1"
              />
            </Link>
            <div className="flex flex-col justify-between text-base_600 hover:text-base_900">
              <h1 className="font-semibold text-base md:text-lg">
                Capacity Building Service Group
              </h1>
              <div className="font-semibold text-xs overflow-hidden text-base_600 text-start">
                <AnimatePresence mode="wait">
                  <motion.div
                    key={country}
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.6 }}
                  >
                    {country}
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </div>

          <div className="dropdown dropdown-bottom dropdown-end z-[100]">
            <div
              tabIndex={0}
              role="button"
              className="text-base_600 font-extrabold text-xl md:text-2xl cursor-pointer px-3">
              <ImMenu />
            </div>
            <ul
              tabIndex={0}
              className="menu menu-sm dropdown-content bg-base-100 z-[1] mt-3 w-56 p-3 shadow-lg rounded-lg overflow-y-auto h-auto whitespace-normal font-semibold text-base_600">
              <li>
                <Link to="/" className={`w-full ${isActive("/") ? activeClass : ""}`}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/About" className={`w-full ${isActive("/About") ? activeClass : ""}`}>
                  About us
                </Link>
              </li>
              <li>
                <p className="font-semibold">Our services</p>
                <ul className="pl-4">
                  <li>
                    <Link to="/Services/Organization-Development" 
                      className={isActive("/Services/Organization-Development") ? activeClass : ""}>
                      Organization Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/Services/Research&Evaluation"
                      className={isActive("/Services/Research&Evaluation") ? activeClass : ""}>
                      Research and Evaluation
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <p className="font-semibold">Sectoral presence</p>
                <ul className="pl-4">
                  {cardData?.map((item) => (
                    <li key={item.id}>
                      <Link 
                        to={`/practice-areas/${item.id}`}
                        className={isActive(`/practice-areas/${item.id}`) ? activeClass : ""}
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li>
                <p className="font-semibold">Team & career</p>
                <ul className="pl-4">
                  <li>
                    <Link to="/team-career/team" className={isActive("/team-career/team") ? activeClass : ""}>
                      Team members
                    </Link>
                  </li>
                  <li>
                    <Link to="/team-career/career" className={isActive("/team-career/career") ? activeClass : ""}>
                      Career Opportunity
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/work-reach" className={isActive("/work-reach") ? activeClass : ""}>
                  Our work & reach
                </Link>
              </li>
              
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

Phonenav.propTypes = {
  className: PropTypes.string,
  cardData: PropTypes.array.isRequired,
};
